import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";
import { SingleLayout } from "./layouts";

// Route Views
import Errors from "./views/Errors";
import HomePage from "./views/Home";
import { EfectoresAdminPage } from "./views/efectores";
import NotificacionesPage from "./views/Notificaciones";
import Login from "./views/Login";
import ResetPassword from "./views/ResetPassword";
import ChangePassword from "./views/ChangePassword";
import DetalleInternacionPage from "./views/DetalleInternacion";
import DetalleInternacionEfectorPage from "./views/DetalleInternacionEfector";
import Unauthorized from "./views/Unauthorized";

export default [
  {
    name: "index",
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/home" />
  },
  {
    name: 'home',
    path: "/home",
    layout: DefaultLayout,
    component: HomePage
  },
  {
    name: 'login',
    path: "/login",
    layout: SingleLayout,
    component: Login
  },
  {
    name: 'forgot-password',
    path: "/forgot-password",
    layout: SingleLayout,
    component: ResetPassword
  },
  {
    name: 'notifications',
    path: "/notificaciones",
    layout: DefaultLayout,
    component: NotificacionesPage
  },
  {
    name: 'change-password',
    path: "/change-password",
    layout: DefaultLayout,
    component: ChangePassword
  },
  {
    name: 'efectores',
    path: "/efectores",
    layout: DefaultLayout,
    component: EfectoresAdminPage
  },
  {
    name: 'detalle-internacion-efector',
    path: "/detalle-internacion/:internacion_id/efector/:efector_id",
    layout: DefaultLayout,
    component: DetalleInternacionEfectorPage
  },
  {
    name: 'detalle-internacion',
    path: "/detalle-internacion/:id",
    layout: DefaultLayout,
    component: DetalleInternacionPage
  },
  {
    name: 'unauthorized',
    path: "/401",
    layout: SingleLayout,
    component: Unauthorized
  },
  {
    name: 'error',
    path: "*",
    layout: DefaultLayout,
    component: Errors
  },
];
